export default __webpack_public_path__ + "static/media/aboutUs-photo.51787373.png";